import { FormControl, FormLabel, Input } from '@tradener/lumen';

import useComplementForm from '../useComplementForm';

function PickExternalId() {
  const { register } = useComplementForm();

  return (
    <FormControl display="flex" flexDirection="column" gap="1.5">
      <FormLabel margin="0">Ref. Externa</FormLabel>
      <Input id="externalId" {...register('externalId')} />
    </FormControl>
  );
}

export default PickExternalId;
